import {FC, ReactNode} from 'react';
import * as S from './Shimmer.styles';

interface ShimmerProps {
  width?: string;
  height?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  marginTop?: string;
  radius?: string;
  customStyle?: object;
  shimmerColor?: string;
  backgroundColor?: string;
  children?: ReactNode;
}

const Shimmer: FC<ShimmerProps> = ({
  width,
  height,
  marginLeft,
  marginRight,
  marginBottom,
  marginTop,
  radius,
  customStyle,
  shimmerColor,
  backgroundColor,
  children,
}) => {
  return (
    <S.Placeholder
      width={width}
      height={height}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginTop={marginTop}
      radius={radius}
      style={{...customStyle}}
      shimmerColor={shimmerColor}
      backgroundColor={backgroundColor}
    >
      {children}
    </S.Placeholder>
  );
};
export default Shimmer;
